import { Pipe, PipeTransform } from '@angular/core';
import { ParticipationComponent } from '../participation/participation.component';
import { Group, Matrix } from '../common-class/pages';
import { EditResponseComponent } from '../edit-response/edit-response.component';
import { SurveyPreviewComponent } from '../survey-preview/survey-preview.component';

@Pipe({
  name: 'getmatrixgroup'
})
export class MatrixGroupPipe implements PipeTransform {

  constructor(private participation: ParticipationComponent) { }

  transform(matrix: Matrix, args?: any): Group[] {
    return this.participation.GetGroupDatas(matrix)
  }
}


@Pipe({
  name: 'getmatrixgroupedit'
})
export class MatrixGroupPipeEdit implements PipeTransform {

  constructor(private edtResponse: EditResponseComponent) { }

  transform(matrix: Matrix, args?: any): Group[] {
    return this.edtResponse.GetGroupDatas(matrix)
  }
}

@Pipe({
  name: 'getmatrixpreview'
})
export class MatrixPipePreview implements PipeTransform {

  constructor(private surveyPreview: SurveyPreviewComponent) { }

  transform(group: Group, args?: any): Matrix {
    // Try to get matrix data from the survey
    const matrixData = this.surveyPreview.getMatrixData(group);
    
    // If no matrix data found, create a default matrix structure for grid questions
    if (matrixData.matrix_id === 1 && matrixData.Mtitle === 'Default Matrix') {
      // Create a default matrix structure based on the group type
      const defaultMatrix = new Matrix();
      defaultMatrix.matrix_id = group.Matrix_id || 1;
      defaultMatrix.Mtitle = this.getMatrixTitleFromGroup(group);
      defaultMatrix.PipeMTitle = '';
      defaultMatrix.questiontip = '';
      defaultMatrix.QPos = 0;
      
      // Set matrix properties based on group type
      if (group.gtitle?.includes('Multiple Text Box') || group.gtitle?.includes('Attachment') || group.gtitle?.includes('Signature')) {
        defaultMatrix.isMulti = true; // These question types have multiple sub-questions
        defaultMatrix.MultiColumnCount = 3; // Default to 3 sub-questions
        defaultMatrix.IsSingleGrid = false; // Not a single grid
      } else {
        defaultMatrix.isMulti = false; // Grid questions are typically single
        defaultMatrix.MultiColumnCount = 0;
        defaultMatrix.IsSingleGrid = true; // Grid questions are typically single grid
      }
      
      defaultMatrix.subq_col_width = 0;
      defaultMatrix.totalwidth = 0;
      defaultMatrix.VerticalSpaceCount = 0;
      defaultMatrix.isBranchEnabled = false;
      defaultMatrix.SourceGrid = 0;
      defaultMatrix.SourcePosition = 0;
      defaultMatrix.SourceNumber = 0;
      defaultMatrix.TargetGrid = 0;
      defaultMatrix.isDisplayManage = false;
      defaultMatrix.isOverAllStyleApplied = true;
      defaultMatrix.isHiddenQ = false;
      
      return defaultMatrix;
    }
    
    return matrixData;
  }

  /**
   * Get matrix title based on group type
   */
  private getMatrixTitleFromGroup(group: Group): string {
    if (group.gtitle?.includes('Grid Radio')) {
      return 'Radio Grid Matrix';
    } else if (group.gtitle?.includes('Grid Checkbox')) {
      return 'Checkbox Grid Matrix';
    } else if (group.gtitle?.includes('Single Choice Grid')) {
      return 'Single Choice Grid Matrix';
    } else if (group.gtitle?.includes('Matrix Grid')) {
      return 'Matrix Grid';
    } else if (group.gtitle?.includes('Multiple Text Box')) {
      return 'Multiple Text Box Matrix';
    } else if (group.gtitle?.includes('Attachment')) {
      return 'Attachment Matrix';
    } else if (group.gtitle?.includes('Signature')) {
      return 'Signature Matrix';
    }
    return 'Grid Matrix';
  }
}
